import React from "react";

import { getTodosClienteServicosFinanceiros } from "../../../services/cliente";
import {
  guardarDadosUsuario,
  guardarDadosUsuario2,
  obterDadosUsuario2,
} from "../../../services/cookies";
import { renovacaoToken } from "../../../services/usuario";
import { Cliente } from "../ListarUsuarios/functions";

interface ObterTodosOsClientesPorServicoFinanceiroProps {
  idServicoFinanceiro: number;
  numeroPagina: number;
  tamanhoPagina: number;
  setLoading: React.Dispatch<boolean>;
  setErro: React.Dispatch<boolean>;
  setListaClientesPrivate: React.Dispatch<React.SetStateAction<Cliente[]>>;
  setDesconectar: React.Dispatch<boolean>;
}

const erroNaoAutorizado = (err: any) =>
  err?.response?.status === 401 || String(err).includes("status code 401");

const guardarTokensRenovados = (res: any) => {
  const dadosUsuario = obterDadosUsuario2();
  const tokenAcesso = res.data.camposAdicionais.tokenAcesso;
  const tokenRenovacao = res.data.camposAdicionais.tokenRenovacao;
  const email = dadosUsuario.email?.toString() || "";
  const id = dadosUsuario.id?.toString() || "";

  guardarDadosUsuario(tokenAcesso, tokenRenovacao, email, id, dadosUsuario.urlAvatar || undefined);
  guardarDadosUsuario2(tokenAcesso, tokenRenovacao, email, id, dadosUsuario.urlAvatar || undefined);

  return tokenAcesso;
};

export const FunctionObterClientesPrivate = ({
  idServicoFinanceiro,
  numeroPagina,
  tamanhoPagina,
  setLoading,
  setErro,
  setListaClientesPrivate,
  setDesconectar,
}: ObterTodosOsClientesPorServicoFinanceiroProps) => {
  async function obterTodosOsClientesPrivate() {
    setLoading(true);
    setErro(false);

    const { token, tokenRenovacao } = obterDadosUsuario2();

    try {
      const res = await getTodosClienteServicosFinanceiros(
        token,
        idServicoFinanceiro,
        numeroPagina,
        tamanhoPagina
      );

      setListaClientesPrivate(res.data.resultado.clientes);
    } catch (err) {
      if (!erroNaoAutorizado(err)) {
        setErro(true);
        return;
      }

      try {
        const resToken = await renovacaoToken(token, tokenRenovacao);
        const tokenAcesso = guardarTokensRenovados(resToken);
        const res = await getTodosClienteServicosFinanceiros(
          tokenAcesso,
          idServicoFinanceiro,
          numeroPagina,
          tamanhoPagina
        );

        setListaClientesPrivate(res.data.resultado.clientes);
      } catch (retryErr) {
        if (erroNaoAutorizado(retryErr)) {
          setDesconectar(true);
          return;
        }

        setErro(true);
      }
    } finally {
      setLoading(false);
    }
  }

  return {
    obterTodosOsClientesPrivate,
  };
};
